<template>
  <div
    :class="['stake-row', { 'has-divider': hasDivider }]"
    @click="
      $router.push({
        path: '/stake/' + dataItem.projectName,
      })
    "
  >
    <div class="pa-6 clickable rounded-24">
      <div class="d-flex text-5 text-uppercase font-weight-medium">
        <div class="flex-2 d-flex align-center">
          <span>{{ dataItem.name }}</span>
          <v-tooltip bottom :color="statusMap[dataItem.status.status].color">
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                :src="statusMap[dataItem.status.status].symbol"
                height="10"
                width="10"
                alt=""
                class="ml-2"
              />
            </template>
            <div class="text-6">
              {{ dataItem.status.displayStatus }}
            </div>
          </v-tooltip>
        </div>
        <div class="flex-2 text-right">
          {{ dataItem.uptime | numberFormat("0,0.00") }}%
        </div>
        <div class="flex-2 text-right">
          <span v-if="dataItem.votingPower.percentage"
            >{{
              dataItem.votingPower.percentage | numberFormat("0,0.00", false)
            }}%</span
          >
          <span v-else>-</span>
        </div>
        <div class="flex-2 text-right">
          ${{ dataItem.totalStakedAUM | numberFormat("0,0") }}
        </div>
        <div class="flex-2 text-right">
          <v-tooltip
            bottom
            color="dark"
            min-width="170"
            v-if="dataItem.variesApy"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="text-capitalize">Varies APY</span>
            </template>
            <div class="text-6">
              Dependent on transaction fees
            </div>
          </v-tooltip>
          <span v-else
            >{{ dataItem.yield3Days.apy | numberFormat("0,0.00", false) }}%
            APY</span
          >
        </div>
        <div class="flex-2 text-right">
          <!-- <v-tooltip bottom color="dark" min-width="170" disabled>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"
              >{{ dataItem.yield15Days.apy | numberFormat("0,0.00", false) }}%
              APY</span
            >
          </template>
          <div class="text-6">
            APY Tooltips (disbaled)
          </div>
        </v-tooltip> -->
        </div>
        <div class="flex-1 text-right">
          <v-tooltip bottom color="dark">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <img
                  :src="dataItem.market.logo"
                  height="20"
                  width="20"
                  :alt="dataItem.market.name"
                />
              </span>
            </template>
            <span>{{ dataItem.market.name }}</span>
          </v-tooltip>
        </div>
      </div>
      <div class="d-flex text-6">
        <div class="flex-2">
          <span class="gray--text text-uppercase">{{
            dataItem.tokenName
          }}</span>
          <span class="darkgray--text ml-1"
            >${{ dataItem.tokenPrice | currency }}</span
          >
        </div>
        <div class="flex-2"></div>
        <div class="flex-2 text-right">
          <span v-if="dataItem.votingPower.value">
            <span class="darkgray--text font-weight-medium">{{
              dataItem.votingPower.value | numberFormat("0,0")
            }}</span>
            <span class="gray--text text-uppercase ml-1">{{
              dataItem.token
            }}</span>
          </span>
        </div>
        <div class="flex-2 text-right">
          <span class="gray--text">24h</span>
          <span
            :class="[
              'ml-1',
              {
                'green--text':
                  dataItem.balanceChange24h.totalStakedAUM.percentage > 0,
                'red--text':
                  dataItem.balanceChange24h.totalStakedAUM.percentage < 0,
                'darkgray--text':
                  dataItem.balanceChange24h.totalStakedAUM.percentage === 0,
              },
            ]"
            ><span></span>
            <span
              ><span v-if="dataItem.balanceChange24h.totalStakedAUM.value < 0"
                >–</span
              >${{
                dataItem.balanceChange24h.totalStakedAUM.value
                  | abs
                  | numberFormat("0,0")
              }}</span
            >
            <span class="ml-1"
              >(<span v-if="dataItem.balanceChange24h.totalStakedAUM.value < 0"
                >–</span
              ><span v-if="dataItem.balanceChange24h.totalStakedAUM.value > 0"
                >+</span
              ><span
                >{{
                  dataItem.balanceChange24h.totalStakedAUM.percentage
                    | abs
                    | numberFormat("0,0.00", false)
                }}%</span
              >)</span
            ></span
          >
        </div>
        <div class="flex-2 text-right">
          <!-- <span class="gray--text">ROI</span>
        <span class="darkgray--text ml-1">
          <span v-if="dataItem.yield3Days.ROI"
            >{{
              dataItem.yield3Days.ROI | numberFormat("0,0.00", false)
            }}%</span
          >
          <span v-else>-</span>
        </span> -->
        </div>
        <div class="flex-2 text-right">
          <!-- <span class="gray--text">ROI</span>
        <span class="darkgray--text ml-1">
          <span v-if="dataItem.yield15Days.ROI"
            >{{
              dataItem.yield15Days.ROI | numberFormat("0,0.00", false)
            }}%</span
          >
          <span v-else>-</span>
        </span> -->
        </div>
        <div class="flex-1"></div>
      </div>
    </div>
  </div>
</template>

<script>
const statusMap = {
  live: {
    symbol: require("@/assets/icons/status-live.svg"),
    color: "#00A253",
  },
  maintenance: {
    symbol: require("@/assets/icons/status-maintenance.svg"),
    color: "#FFA600",
  },
  offline: {
    symbol: require("@/assets/icons/status-offline.svg"),
    color: "#EB5757",
  },
};
export default {
  props: {
    dataItem: Object,
    hasDivider: Boolean,
  },
  data: () => ({
    statusMap,
  }),
};
</script>

<style lang="scss" scoped>
.stake-row {
  &.has-divider {
    border-top: 1px solid #e9ebff;
  }
}
</style>
